module.exports = __webpack_public_path__ + "static/img/event3.c2c4cb2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/event3.png
// module id = kTYh
// module chunks = 1